<div class="card card-custom">
  <div class="card-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div class="card-title">
      <h3 class="card-label" translate>{{ getTitle() }}</h3>
    </div>
  </div>
  <form class="form form-group-seperator-dashed" [formGroup]="drugForm">
    <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
      <div class="card-body-progress">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>
      <kt-alert *ngIf="hasFormErrors" type="warn" [showCloseButton]="false" [duration]="10000">
        {{ 'AUTH.VALIDATION.INVALID_OR_REQUIRED' | translate }}
      </kt-alert>
      <div class="form-group">
        <div class="row">
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="DRUG.FORM.DRUG">Drug</mat-label>
              <input matInput formControlName="drug" />
              <mat-error *ngIf="isControlHasError('drug', 'required')">
                Drug is
                <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="DRUG.FORM.STRENGTH">Strength</mat-label>
              <input matInput type="number" formControlName="strength" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="DRUG.FORM.UNIT">Unit</mat-label>
              <input matInput formControlName="unit" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="DRUG.FORM.NDC">NDC</mat-label>
              <input matInput formControlName="ndc" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="DRUG.FORM.DDID">DDID</mat-label>
              <input matInput formControlName="ddid" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="DRUG.FORM.UPC_CODE">UPC Code</mat-label>
              <input matInput formControlName="upc_code" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="DRUG.FORM.BRAND">Brand</mat-label>
              <input matInput formControlName="brand" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="DRUG.FORM.GENERIC">Generic</mat-label>
              <input matInput formControlName="generic" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="DRUG.FORM.TH_CLASS">Therapeutic Class</mat-label>
              <input matInput formControlName="th_class" />
            </mat-form-field>
          </div>

          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="DRUG.FORM.DRUG_SCHEDULE">Drug Schedule</mat-label>
              <mat-select formControlName="drug_schedule">
                <mat-option value="0">0</mat-option>
                <mat-option value="2">2</mat-option>
                <mat-option value="3">3</mat-option>
                <mat-option value="4">4</mat-option>
                <mat-option value="5">5</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <kt-general-autocomplete
              [label]="'Drug Group'"
              [loadItemsFunction]="drugGroupAutocompleteCall"
              [optionFormatter]="filterDrugGroupFn"
              [valueFormatter]="filterDrugGroupFn"
              [required]="true"
              [readOnly]="false"
              [control]="drugForm.get('drug_group')"
              [change]="onDrugGroupChange.bind(this)"
              [dataPath]="'data'"
              [placeholder]="'Select Drug Group'"
              #drugGroupAutocomplete
            ></kt-general-autocomplete>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="DRUG.FORM.PACK_SIZE">Pack Size</mat-label>
              <input matInput formControlName="pack_size" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="DRUG.FORM.CFI">CFI</mat-label>
              <input matInput formControlName="cfi" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="DRUG.FORM.HICL_SEQNO">HICL Seq No</mat-label>
              <input matInput formControlName="hicl_seqno" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="DRUG.FORM.JCODE">J-Code Assistance URL</mat-label>
              <input matInput formControlName="jcode" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="DRUG.FORM.GPI">GPI</mat-label>
              <input matInput formControlName="gpi" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="DRUG.FORM.RXCUI">RXCUI</mat-label>
              <input matInput formControlName="rxcui" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile"></div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-checkbox
              formControlName="brand_generic_flag"
              translate="DRUG.FORM.BRAND_GENERIC_FLAG"
              >Generic Brand
            </mat-checkbox>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-checkbox formControlName="otc_flag" translate="DRUG.FORM.OTC_FLAG"
              >OTC</mat-checkbox
            >
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            (click)="close()"
            type="button"
            mat-raised-button
            cdkFocusInitial
            matTooltip="Cancel"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            type="button"
            mat-raised-button
            color="primary"
            [disabled]="clicked"
            (click)="onSubmit()"
            matTooltip="Create"
          >
            <span translate="GLOBAL.SAVE">Save</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
